/**
 * Created by PRIME AI.
 * @author Samuel Hinchliffe <samuel@primeai.co.uk, sam.hinchliffe.work@gmail.com>
 * @see    [Linkedin] {@link https://www.linkedin.com/in/samuel-hinchliffe-2bb5801a5/}
 *
 * @summary This is an app. An App encapsulates all the required logic to load in
 * components.
 *
 * Created at: 25/10/2023
 * @see       [PRIME-AI GITHUB] {@link https://github.com/PRIME-AI-GITHUB}
 * @see       [Website]         {@link https://www.primeai.co.uk/}
 * @copyright 2018-2023 PRIME AI LTD
*/

import RecommendationCTA from '../Components/SizeView/RecommendationCTA';
import RecommendationWindow from '../Components/SizeView/RecommendationWindow';
import {
    Log, App, AppNotAllowedError, CacheStorage,
} from '../../modules/WidgetWorks/WidgetWorks';

export default class SizeView extends App {
    constructor(config, appFactory) {
        super(config, appFactory);
    }

    overrideHook() {}

    preLoad() {}

    postLoad() {
        this.runPostLoadAnalyticsEvent();
    }

    async isAppAllowedToRun() {
        // !! add url ifs here.

        if (!this.isAppAllowedToRunDueToABTest()) return { result: false, reason: 'AB Test is running, this app is not allowed to run due to the flag being false.' };

        return false;
    }

    runPostLoadAnalyticsEvent() {
    }

    isAppAllowedToRunDueToABTest() {
        if (!this.config.abTest) return true;

        // Does the user already have a ab test flag?
        const flag = localStorage.getItem('PRIME_AI_FCBP_APP_AB_TEST');

        // If the flag is null, it means the AB test is not happening at all.
        if (flag === null || flag === 'false') return false;

        // If the flag is 'true', it means an AB test is going on and the app should not run.
        if (flag === 'true') return true;

        // Enabled in the config and the user has not been assigned a flag.
        if (flag == null) {
            const result = Math.random() < 0.5;
            localStorage.setItem('PRIME_AI_FCBP_APP_AB_TEST', result);
            return result === 'true';
        }

        // Default to true.
        return true;
    }

    runViewAnalyticsEvent() {
    }

    async init() {
        try {
            // return false;
            // Run the over-ride hook.
            this.overrideHook();

            // Run the preload hook.
            this.preLoad();

            // Load Product Recommendation App.
            await this.loadApp();

            // Run the post-load hook.
            this.postLoad();

            return true;
        } catch (error) {
            if (error instanceof AppNotAllowedError) {
                console.error('Failed to initialize:', error);
                console.log(...Log.w(`${this.constructor.name}`, 'ERROR', `AppNotAllowedError Failed to load 1 or more apps: ${error}`));
                return false;
            }
            this.sentry.captureException(error);
            console.error('Critical Error:', error);
            console.log(...Log.w(`${this.constructor.name}`, 'ERROR', `Critical Error Failed to load 1 or more apps: ${error}`));
            return false;
        }
    }

    async loadApp() {
        // Compile the apps details. Download their URLs, inject their styles, build the elements.
        const windowAppDetails = await this.appFactory.compileApp(this.config.apps.SizeViewRecommendationWindow);
        const CtaAppDetails = await this.appFactory.compileApp(this.config.apps.SizeViewRecommendationCTA);

        // Pass the app details to the app to run the app.
        this.recommendationCTA = new RecommendationCTA(CtaAppDetails);
        const ctaLoaded = this.recommendationCTA.init(); // ADD ASYNC IF YOU WANT IT TO WAIT

        this.recommendationWindow = new RecommendationWindow(windowAppDetails);
        const windowLoaded = this.recommendationWindow.init(); // ADD ASYNC IF YOU WANT IT TO WAIT

        // Build a connection between the apps, similar to an event emitter system.
        this.recommendationWindow.connections.recommendationCTA = this.recommendationCTA;
        this.recommendationCTA.connections.recommendationWindow = this.recommendationWindow;

        // Do not continue until both apps have loaded.
        await Promise.all([ctaLoaded, windowLoaded]);

        return true;
    }
}
